import { useState } from "react";
import SidePanel from "../../components/SidePanel";
import { toast } from "react-toastify";
import Spinner from "../../components/Spinner";

const Settings = () => {
  const [loader, setLoader] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const handleChange = async (e) => {
    e.preventDefault();
    setLoader(true);
    const token = localStorage?.getItem("token");
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/change-password`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-sh-auth": token,
      },
      body: JSON.stringify({
        oldPassword: currentPassword,
        newPassword,
        confirmPassword: confirmNewPassword,
      }),
    });
    const data = await res.json();
    const status = data.code;
    setLoader(false);
    if (status === 200) {
      toast.success("Password Changed Successfully");
    } else {
      toast.error(data.message);
    }
  };

  return (
    <section className="flex">
      <SidePanel />
      <div className="w-full xl:pl-[20%] lg:pl-10 md:pl-6 sm:pl-4 pl-2 pt-[6rem] px-4">
        <h1 className="text-4xl text-gray-500 font-bold sm:text-left text-center mb-5">
          Settings
        </h1>
        <form className="my-10 space-y-4" onSubmit={handleChange}>
          <div className="flex flex-col w-full text-xl">
            <label className="text-lg mb-1">Current Password</label>
            <input
              type="password"
              name="currentPassword"
              required
              value={currentPassword || ""}
              onChange={(e) => setCurrentPassword(e.target.value)} // You might need a new handler to update the recipients state
              className="w-full bg-slate-100 py-2 rounded-md px-3"
            />
          </div>
          <div className="flex flex-col w-full text-2xl">
            <label className="text-lg mb-1">New Password</label>

            <input
              type="password"
              name="newPassword"
              required
              value={newPassword || ""}
              onChange={(e) => setNewPassword(e.target.value)} // You might need a new handler to update the recipients state
              className="w-full bg-slate-100 py-2 rounded-md px-3"
            />
          </div>
          <div className="flex flex-col w-full text-2xl">
            <label className="text-lg mb-1">Confirm New Password</label>
            <input
              type="password"
              name="confirmNewPassword"
              required
              value={confirmNewPassword || ""}
              onChange={(e) => setConfirmNewPassword(e.target.value)} // You might need a new handler to update the recipients state
              className="w-full bg-slate-100 py-2 rounded-md px-3"
            />
          </div>
          {loader ? (
            <Spinner props={" "} size={"80"} />
          ) : (
            <button className="bg-primary rounded-md py-3 text-white sm:text-xl w-full hover:opacity-90">
              Change Password
            </button>
          )}
        </form>
      </div>
    </section>
  );
};

export default Settings;
